import { KeyboardEvent, useState } from "react";
import {
	BLOCKED_CHARS_MESSAGE,
	BLOCKED_NUMBER_KEYS,
	stripBlockedChars,
} from "../utils/blocked-chars";

export interface UseBlockedCharsResult {
	handleChangeText: (field: string, rawValue: string) => void;
	handleKeyDownNumber: (event: KeyboardEvent<HTMLDivElement>) => void;
	helperTextFor: (field: string) => string | undefined;
	resetBlockedChars: () => void;
}

export function useBlockedChars(
	setFieldValue: (field: string, value: string) => unknown,
): UseBlockedCharsResult {
	const [blockedCharsFields, setBlockedCharsFields] = useState<
		Record<string, boolean>
	>({});

	const handleChangeText = (field: string, rawValue: string) => {
		const value = stripBlockedChars(rawValue);
		setFieldValue(field, value);
		setBlockedCharsFields((current) => ({
			...current,
			[field]: value === "" ? false : current[field] || value !== rawValue,
		}));
	};

	const handleKeyDownNumber = (event: KeyboardEvent<HTMLDivElement>) => {
		if (BLOCKED_NUMBER_KEYS.includes(event.key)) event.preventDefault();
	};

	const helperTextFor = (field: string) =>
		blockedCharsFields[field] ? BLOCKED_CHARS_MESSAGE : undefined;

	const resetBlockedChars = () => setBlockedCharsFields({});

	return {
		handleChangeText,
		handleKeyDownNumber,
		helperTextFor,
		resetBlockedChars,
	};
}
